import React, {useState} from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {FaRegEyeSlash} from 'react-icons/fa';
import styles from './login.module.css';
import Google from '../../Assets/google-icon.png';
import  Twitter from '../../Assets/twitter-icon.png';
import  Facebook from '../../Assets/fb-icon.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';



const LoginForm = () => {
  let navigate = useNavigate();
  const userInfo = (values) => {
    axios.post('https://aphrodite-01.herokuapp.com/auth/signin', values)
    .then((response) =>{
      localStorage.setItem("token", response.data.accessToken)
      console.log(response);
      navigate('/dashboard');
    })
  }
    // Initialize a boolean state as false (i.e. shouldn't show password)
    const [passwordShown, setPasswordShown] = useState(false);

    const togglePassword = () => {
        // When the handler is invoked
        // inverse the boolean state of passwordShown
        setPasswordShown(!passwordShown);
      };
    
    
  // Pass the useFormik() hook initial form values and a submit function that will
  // be called when the form is submitted
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
        email: Yup.string().email('Invalid email address').required('Email is required'),
        password: Yup.string()
        .required('Please Enter your login password!'),
        
      }),
        onSubmit: values => {
        const data = {
          email: values.email,
          password: values.password
        }
        userInfo(data)
    },
  });
  return (
      <div className = {styles.signupForm}>
          <h2 className = {styles.login}>
            Login in to your account to start matching
            </h2>
      <form className = {styles.forms} onSubmit={formik.handleSubmit}>

      <label className = {styles.label} htmlFor="email">Email Address</label> <br />
      <input
        className ={styles.input}
        id="email"
        name="email"
        type="email"
        onChange={formik.handleChange}
        value={formik.values.email}
      /> <br />
      {formik.touched.email && formik.errors.email ? (
         <div>{formik.errors.email}</div>
       ) : null}
       
      <label className = {styles.label} htmlFor="password">Password 
      </label> <br />

       <input
        className = {styles.input}
        id="password"
        minLength = "8"
        name="password"
        type={passwordShown ? "text" : "password"}
        onChange={formik.handleChange}
        value={formik.values.password}
      />
          <FaRegEyeSlash onClick={togglePassword}  size={24}/>
       <br />
      {formik.touched.password && formik.errors.password ? (
         <div>{formik.errors.password}</div>
       ) : null}
       <p className = {styles.p}> Forgot Password? </p>
       <h3 className = {styles.h3}> Or <span className = {styles.black}> Login </span>
       with </h3>
              <div className = {styles.myMediaLogo}>
										<img width="45px" height="45px" src={Twitter} alt="logo"/>
										<img width="45px" height="45px" src={Google} alt="logo"/>
										<img width="45px" height="45px" src={Facebook} alt="logo"/>
							</div>
        <button type="submit"
          className ={styles.submit}>Sign In</button>
 
      </form>
      
      </div>
    
  );

};
export default LoginForm;